import { render, staticRenderFns } from "./NewDocumentView.vue?vue&type=template&id=309bb79e&scoped=true&"
import script from "./NewDocumentView.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentView.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentView.vue?vue&type=style&index=0&id=309bb79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309bb79e",
  null
  
)

export default component.exports